// Carry an unfilled offer's terms to the next tradie (survives navigation, cleared once sent).
const KEY = "tl_pass_on_offer";
const PICK = ["title", "description", "city", "site_address", "site_lat", "site_lng", "start_date", "end_date", "work_dates", "flexible", "duration_days", "day_rate", "required_tools", "extra_tools", "note", "billing", "hours", "hourly_rate", "start_time", "finish_time", "weatherproof"];

export function startPassOn(terms, fromRequestId) {
  const t = Object.fromEntries(PICK.filter((k) => terms?.[k] !== undefined && terms?.[k] !== null).map((k) => [k, terms[k]]));
  if (t.start_date) t.start_date = String(t.start_date).slice(0, 10);
  if (t.end_date) t.end_date = String(t.end_date).slice(0, 10);
  sessionStorage.setItem(KEY, JSON.stringify({ terms: t, from: fromRequestId, at: Date.now() }));
}
export function getPassOn() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
}
export function clearPassOn() { sessionStorage.removeItem(KEY); }
